import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

document.querySelectorAll('.element-ourdifference').forEach((el) => {
  const panels = el.querySelectorAll('.element-panel')
  const indicatorProgress = el.querySelector('.element-indicator-progress')
  const indicatorBlocks = el.querySelectorAll('.element-indicator-block')
  const elementMedia = el.querySelector('.element-media')
  const numPanels = panels.length

  if (window.matchMedia('(min-width: 768px)').matches) {
    const trigger = el.querySelector('.scroll-trigger')
    const sectionContentTop = trigger.querySelector('.section-content-top')

    gsap.to(panels, {
      yPercent: -100 * (numPanels - 1),
      ease: 'none',
      scrollTrigger: {
        trigger: trigger,
        pin: true,
        markers: false,
        scrub: 1,
        start: () => {
          const contentTopPadding = parseInt(
            window.getComputedStyle(sectionContentTop, null).getPropertyValue('padding-top')
          )
          const siteHeaderHeight = document.querySelector('.site-header').offsetHeight - contentTopPadding / 1.5
          el.style.setProperty('--_scroll-start-offset', `${contentTopPadding / 1.25}px`)

          return `top ${siteHeaderHeight}`
        },
        end: () => `+=${trigger.offsetHeight * 2}`,
        onUpdate: (self) => {
          const pos = Math.floor(self.progress * numPanels)
          const index = pos >= numPanels ? numPanels : pos + 1

          indicatorBlocks.forEach((x) => {
            if (parseInt(x.dataset.index) <= index) {
              x.classList.add('is-active')
            } else {
              x.classList.remove('is-active')
            }
          })

          elementMedia.querySelectorAll('.element-media-item').forEach((x) => x.classList.remove('is-active'))
          elementMedia.querySelector(`.element-media-item[data-index="${index}"]`).classList.add('is-active')

          indicatorProgress.style.height = `${self.progress * 100}%`
        },
      },
    })
  } else {
    const trigger = el.querySelector('.scroll-trigger-sm')

    gsap.to(panels, {
      xPercent: -100 * (numPanels - 1),
      ease: 'none',
      scrollTrigger: {
        trigger: trigger,
        pin: true,
        markers: false,
        scrub: 1,
        start: () => {
          const siteHeaderHeight = document.querySelector('.site-header').offsetHeight

          return `top ${siteHeaderHeight}`
        },
        end: () => `+=${trigger.offsetWidth * 2}`,
        onUpdate: (self) => {
          const pos = Math.floor(self.progress * numPanels)
          const index = pos >= numPanels ? numPanels : pos + 1

          indicatorBlocks.forEach((x) => {
            if (parseInt(x.dataset.index) <= index) {
              x.classList.add('is-active')
            } else {
              x.classList.remove('is-active')
            }
          })

          elementMedia.querySelectorAll('.element-media-item').forEach((x) => x.classList.remove('is-active'))
          elementMedia.querySelector(`.element-media-item[data-index="${index}"]`).classList.add('is-active')

          indicatorProgress.style.width = `${self.progress * 100}%`
        },
      },
    })
  }
})
